import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { NameRepresentation, NameSortation } from 'common/enum/user.setting.enum';
import {
  getNameSortValue as getNameSortValueBySortation,
  getStudentFullName,
  getUserFullName,
  getUserFullNameOrEmail,
  getUserInitials as getUserInitialsByRepresentation,
  IGenericPerson,
} from 'common/utils/name.utils';
import { computed } from 'vue';

// Backed by the pinia store (not the whoami query) so it is safe to call from plain
// util functions as well; store reads inside computeds keep full reactivity.
export function useDisplayName() {
  const whoAmIStore = useWhoAmIStore();

  const nameRepresentation = computed<NameRepresentation>(
    () => whoAmIStore.whoAmI?.nameRepresentation ?? NameRepresentation.firstNameBeforeLastName,
  );
  const nameSortation = computed<NameSortation>(
    () => whoAmIStore.whoAmI?.nameSortation ?? NameSortation.sortByLastName,
  );

  const getStudentDisplayName = (student: IGenericPerson): string =>
    getStudentFullName(student, nameRepresentation.value);

  const getUserDisplayName = (user: IGenericPerson): string => getUserFullName(user, nameRepresentation.value);

  const getUserDisplayNameOrEmail = (user: IGenericPerson): string =>
    getUserFullNameOrEmail(user, nameRepresentation.value);

  const getUserInitials = (user: IGenericPerson): string =>
    getUserInitialsByRepresentation(user, nameRepresentation.value);

  const getNameSortValue = (person: IGenericPerson): string => getNameSortValueBySortation(person, nameSortation.value);

  return {
    nameRepresentation,
    nameSortation,
    getStudentDisplayName,
    getUserDisplayName,
    getUserDisplayNameOrEmail,
    getUserInitials,
    getNameSortValue,
  };
}
